// Allowed state transitions per object type. The core API enforces these for every
// surface (app, Teams, MCP, agents), so no client can skip a step.
export const workflows: Record<string, { initial: string; transitions: Record<string, string[]> }> = {
  issue: {
    initial: "new",
    transitions: {
      new: ["triaged", "escalated", "closed"],
      triaged: ["in_progress", "escalated", "resolved"],
      in_progress: ["resolved", "escalated"],
      resolved: ["closed", "in_progress"],
      escalated: ["closed"],
      closed: [],
    },
  },
  capa: {
    initial: "initiated",
    transitions: {
      initiated: ["containment", "cancelled"],
      containment: ["investigation", "cancelled"],
      investigation: ["action_plan", "cancelled"],
      action_plan: ["implementation", "investigation", "cancelled"],
      implementation: ["effectiveness_check"],
      effectiveness_check: ["closed", "investigation"],
      closed: [],
      cancelled: [],
    },
  },
};

// Accounts: a prospect is qualified, then becomes a customer only by linking or creating its BC customer
// (POST /api/accounts/:id/customers or /convert), never by a plain stage change.
workflows.account = {
  initial: "prospect",
  transitions: {
    prospect: ["qualified", "inactive"],
    qualified: ["prospect", "inactive"],
    customer: ["inactive"],
    inactive: ["prospect"],
  },
};

export function canTransition(type: string, from: string, to: string): boolean {
  return workflows[type]?.transitions[from]?.includes(to) ?? false;
}
